export default __webpack_public_path__ + "static/medical-marijuana-28494d06e1512eb09d7e2a65530ce8e4.jpg";